import { badge } from "../utils/badgeColors";
// Filter-related types

export type FilterColorScheme = "orange" | "purple" | "green" | "blue" | "pink";

export interface FilterBadgeConfig {
  label: string;
  colorScheme: FilterColorScheme;
  onClear: () => void;
}

// Classes
export const FILTER_COLOR_SCHEMES: Record<FilterColorScheme, string> = {
  orange: badge("orange"),
  purple: badge("purple"),
  green: badge("green"),
  blue: badge("blue"),
  pink: badge("pink"),
};
